export const MODALS_IDS = {
  ADD_TEAM_MEMBERS_MODAL: 'add-team-members-modal',
  TRIM_AUDIO_MODAL: 'trim-audio-modal',
  TRIM_VIDEO_MODAL: 'trim-video-modal',
  CONFIRM_DELETE_MODAL: 'confirm-delete-modal',
  COMPLETE_SIGNUP_MODAL: 'complete-signup-modal',
  CONFIRMATION_MODAL: 'confirmation-modal',
  CONFIRM_REMOVE_VIDEO_BACKGROUND_MODAL: 'confirm-remove-video-background-modal',
  DESIGN_SELECTOR_MODAL: 'design-selector-modal',
  ERROR_MODAL: 'error-modal',
  CROPPER_MODAL: 'cropper-modal',
  VIDEO_CROPPER_MODAL: 'video-cropper-modal',
  POSTER_ITEMS_LIST_MODAL: 'POSTER_ITEMS_LIST_MODAL',
  MASKING_MODAL: 'masking-modal',
  MESSAGE_MODAL: 'message-modal',
  UPLOADING_IMAGES_MODAL: 'uploading-images-modal',
  SAVE_CONFLICT_MODAL: 'save-conflict-modal',
  AUDIO_TYPE_MODAL: 'audio-type-modal',
  USER_MENU_MODAL: 'user-menu-modal',
  USER_MEDIA_MODAL: 'user-media-modal',
  AI_VIDEO_MODAL: 'ai-video-modal',
  STOCK_MODAL: 'stock-media-modal',
  RESUMABLE_STOCK_MODAL: 'resumable-stock-media-modal',
  SHARE_COLLECTION_MODAL: 'share-collection-modal',
  USER_TABLE_MODAL: 'user-table-modal',
  USER_SCHEDULE_MODAL: 'user-schedule-modal',
  MORE_OPTIONS_MODAL: 'more-options-modal',
  COLLECTION_ITEM_MORE_OPTIONS_MODAL: 'collection-item-more-options-modal',
  AUDIO_ITEM_RENAME_MODAL: 'audio-item-legacy-rename-modal',
  REPLACE_MEDIA_MODAL: 'replace-media-modal',
  ROYALTY_FILTERS_MODAL: 'royalty-filters-modal',
  POSTER_IN_GENERATION_MODAL: 'poster-in-generation-modal',
  RESIZE_MODAL: 'resize-modal',
  COLOR_BACKGROUND_MODAL: 'color-background-modal',
  UPLOAD_FONT_AGREEMENT_MODAL: 'upload-font-agreement-modal',
  CHANGE_PLAN_MODAL: 'change-plan-modal',
  FANCYTEXT_MODAL: 'fancytext-modal',
  EVENT_FILTERS_MODAL: 'event-filters-modal',
  EVENT_AREA_FILTERS_MODAL: 'event-area-filters-modal',
  CREATE_EVENT_MODAL: 'create-event-modal',
  EDIT_EVENT_MODAL: 'edit-event-modal',
  PMW_STOCK_UPLOAD_FAILED_MODAL: 'pmw-stock-upload-failed-modal',
  SOCIAL_POSTS_DIALOG_MODAL: 'social-posts-dialog-modal',
  EMAIL_METRICS_DOWNLOAD_PDF_MODAL: 'email-metrics-download-pdf-modal',
  SOCIAL_MEDIA_WIZARD_MOBILE_FOOTER_MODAL: 'social-media-wizard-mobile-footer-modal',
  SOCIAL_ACCOUNTS_CONNECTION_MODAL: 'social-accounts-conntection-modal',
  POSTER_EDITOR_ADD_ITEM_MODAL: 'poster-editor-add-item-modal',
  POSTER_EDITOR_GRID_MODAL: 'poster-editor-grid-modal',
  POSTER_EDITOR_FOLDS_MODAL: 'poster-editor-folds-modal',
  POSTER_EDITOR_TITLE_MODAL: 'poster-editor-title-modal',
  POSTER_EDITOR_PAGE_ANIMATION_MODAL: 'poster-editor-page-animation-modal',
  POSTER_EDITOR_ITEM_ANIMATION_MODAL: 'poster-editor-item-animation-modal',
  POSTER_EDITOR_LAYERS_MODAL: 'poster-editor-layers-modal',
  POSTER_EDITOR_ITEM_POSITION_MODAL: 'poster-editor-item-position-modal',
  POSTER_EDITOR_ITEM_SYMMETRY_MODAL: 'poster-editor-item-symmetry-modal',
  POSTER_EDITOR_ITEM_VOLUME_MODAL: 'poster-editor-item-volume-modal',
  POSTER_EDITOR_ITEM_SPEED_MODAL: 'poster-editor-item-speed-modal',
  POSTER_EDITOR_ITEM_OPACITY_MODAL: 'poster-editor-item-opacity-modal',
  POSTER_EDITOR_ITEM_FONT_SIZE_MODAL: 'poster-editor-item-font-size-modal',
  POSTER_EDITOR_ITEM_FONT_STYLE_MODAL: 'poster-editor-item-font-style-modal',
  POSTER_EDITOR_ITEM_SPELLCHECK_MODAL: 'poster-editor-item-spellcheck-modal',
  POSTER_EDITOR_ITEM_HYPERLINK_MODAL: 'poster-editor-item-hyperlink-modal',
  POSTER_EDITOR_ITEM_ALIGNMENT_MODAL: 'poster-editor-item-alignment-modal',
  POSTER_EDITOR_ITEM_SHADOW_MODAL: 'poster-editor-item-shadow-modal',
  POSTER_EDITOR_ITEM_FLIP_MODAL: 'poster-editor-item-flip-modal',
  POSTER_EDITOR_ITEM_STRETCH_MODAL: 'poster-editor-item-stretch-modal',
  POSTER_EDITOR_ITEM_ADJUSTMENTS_MODAL: 'poster-editor-item-adjustments-modal',
  POSTER_EDITOR_LAYOUT_FILL_MODAL: 'poster-editor-layout-fill-modal',
  POSTER_EDITOR_TEXT_FILL_MODAL: 'poster-editor-text-fill-modal',
  POSTER_EDITOR_TRANSCRIPT_TEXT_FILL_MODAL: 'poster-editor-transcript-text-fill-modal',
  POSTER_EDITOR_TRANSCRIPT_OUTLINE_MODAL: 'poster-editor-transcript-outline-modal',
  POSTER_EDITOR_TRANSCRIPT_ACTIVE_WORD_MODAL: 'poster-editor-transcript-active_word-modal',
  POSTER_EDITOR_ITEM_FILTERS_MODAL: 'poster-editor-item-filters-modal',
  POSTER_EDITOR_ITEM_BACKGROUND_MODAL: 'poster-editor-item-background-modal',
  POSTER_EDITOR_ITEM_EFFECTS_MODAL: 'poster-editor-item-effects-modal',
  POSTER_EDITOR_TEXT_OUTLINE_MODAL: 'poster-editor-text-outline-modal',
  POSTER_EDITOR_QR_CONTENT_MODAL: 'poster-editor-qr-content-modal',
  POSTER_EDITOR_QR_CONTENT_COLOR_MODAL: 'poster-editor-qr-content-color-modal',
  POSTER_EDITOR_QR_CONTENT_BACKGROUND_MODAL: 'poster-editor-qr-content-background-modal',
  POSTER_EDITOR_VECTOR_BORDER_MODAL: 'poster-editor-vector-border-modal',
  POSTER_EDITOR_LINE_THICKNESS_MODAL: 'poster_editor_line_thickness_modal',
  POSTER_EDITOR_LINE_CAP_MODAL: 'poster_editor_line_cap_modal',
  POSTER_EDITOR_LINE_CAP_END_MODAL: 'poster_editor_line_cap_end_modal',
  POSTER_EDITOR_LINE_DASH_MODAL: 'poster_editor_line_dash_modal',
  POSTER_EDITOR_LINE_ROUNDED_CORNERS_MODAL: 'poster_editor_line_rounded-corners_modal',
  POSTER_EDITOR_LINE_COLOR_MODAL: 'poster_editor_line_color_modal',
  POSTER_EDITOR_VECTOR_FILL_MODAL: 'poster-editor-vector-fill-modal',
  POSTER_EDITOR_FANCY_TEXT_MODAL: 'poster-editor-fancy-text-modal',
  POSTER_EDITOR_FANCY_TEXT_EFFECT_MODAL: 'poster-editor-fancy-text-effect-modal',
  POSTER_EDITOR_FANCY_TEXT_FONT_MODAL: 'poster-editor-fancy-text-font-modal',
  POSTER_EDITOR_DRAW_BRUSH_MODAL: 'poster-editor-draw-brush-modal',
  POSTER_EDITOR_DRAW_BRUSH_SIZE_MODAL: 'poster-editor-draw-brush-size-modal',
  POSTER_EDITOR_DRAW_BRUSH_COLOR_MODAL: 'poster-editor-draw-brush-color-modal',
  POSTER_EDITOR_DRAWING_COLOR_MODAL: 'poster-editor-drawing-color-modal',
  POSTER_EDITOR_MORE_OPTIONS_MODAL: 'poster-editor-more-options-modal',
  POSTER_EDITOR_NUMBER_OF_TABS_MODAL: 'poster-editor-number-of-tabs-modal',
  POSTER_EDITOR_TABS_TEXT_MODAL: 'poster-editor-tabs-text-modal',
  POSTER_EDITOR_ITEM_LAYOUT_MODAL: 'poster-editor-item-layout-modal',
  POSTER_EDITOR_ITEM_DATE_STYLES_MODAL: 'poster-editor-item-date-styles-modal',
  POSTER_EDITOR_ITEM_FONT_STYLE_2_MODAL: 'poster-editor-item-font-style-2-modal',
  POSTER_EDITOR_LAYOUT_ITEM_BORDER_MODAL: 'poster-editor-layout-item-border-modal',
  POSTER_EDITOR_LAYOUT_ITEM_SPACING_MODAL: 'poster-editor-layout-item-spacing-modal',
  POSTER_EDITOR_MENU_ITEM_ICON_STYLES_MODAL: 'poster-editor-menu-item-icon-styles-modal',
  POSTER_EDITOR_SLIDESHOW_APPLY_PROPERTIES_MODAL: 'poster-editor-slideshow-apply-properties-modal',
  POSTER_EDITOR_SLIDESHOW_SLIDES_MODAL: 'poster-editor-slideshow-slides-modal',
  POSTER_EDITOR_NAV_MORE_OPTIONS_MODAL: 'poster-editor-nav-more-options-modal',
  POSTER_EDITOR_LANGUAGE_MODAL: 'poster-editor-language-modal',
  POSTER_EDITOR_TEXT_ITEM_FONT_MODAL: 'poster-editor-text-item-font-modal',
  POSTER_EDITOR_BACKGROUND_TYPE_MODAL: 'poster-editor-background-type-modal',
  REPLACE_BACKGROUND_IMAGE_MODAL: 'replace-background-image-modal',
  REPLACE_BACKGROUND_VIDEO_MODAL: 'replace-background-video-modal',
  MOVE_MULTIMEDIA_MODAL: 'move-multimedia-modal',
  ADD_ITEMS_MODAL: 'add-items-modal',
  SOCIAL_MEDIA_RESIZE_OPTIONS: 'social-media-resize-options',
  MY_STUFF_MOBILE_NAVIGATION_MODAL: 'mystuff-mobile-nav-modal',
  USER_EMAIL_VERIFICATION_MODAL: 'user-email-verification-modal',
  USER_EMAIL_VERIFICATION_ERROR_MODAL: 'user-email-verification-error-modal',
  GOOGLE_MAP_SELECTOR_MODAL: 'google-map-selector-modal',
  EVENT_WIZARD_VENUE_MODAL: 'event-wizard-venue-modal',
  EVENT_WIZARD_PREVIEW_MODAL: 'event-wizard-preview-modal',
  EVENT_WIZARD_DATE_TIME_MODAL: 'event-wizard-date-time-modal',
  EMBED_VIDEOS_EMAILMAKER_MODAL: 'embed-videos-emailmaker-modal',
  POSTER_EDITOR_BLEED_MODAL: 'poster-editor-bleed-modal',
  POSTER_EDITOR_LAYOUT_ITEM_FONT_MODAL: 'poster-editor-layout-item-font-modal',
  POSTER_EDITOR_SLIDESHOW_TRANSITION_MODAL: 'poster-editor-slideshow-transition-modal',
  POSTER_EDITOR_FANCY_TEXT_SHAPE_MODAL: 'poster-editor-fancy-text-shape-modal',
  POSTER_EDITOR_TAB_ITEM_SEPARATOR_MODAL: 'poster-editor-tab-item-separator-modal',
  POSTER_EDITOR_FANCY_TEXT_COLORS_MODAL: 'poster-editor-fancy-text-colors-modal',
  POSTER_EDITOR_ITEM_LIST_MODAL: 'poster-editor-item-list-modal',
  DURATION_DROPDOWN_MODAL: 'duration-dropdown-modal',
  EDIT_AUDIO_ITEM_MODAL: 'edit-audio-item-legacy-modal',
  POSTER_EDITOR_EXPORT_MODAL: 'poster-editor-export-modal',
  POSTER_EDITOR_ADD_SLIDESHOW_MODAL: 'poster-editor-add-slideshow-modal',
  ADD_FANCYTEXT_COLOR_MODAL: 'add-fancytext-color-modal',
  AUTO_CAPTIONS_MODAL: 'auto-captions-modal',
  POSTER_EDITOR_EDIT_TEXT_MODAL: 'poster-editor-edit-text-modal',
  MY_STUFF_MOBILE_FOLDER_OPTIONS: 'mystuff-mobile-folder-options-modal',
  EMBEDDED_EDITOR_CONSENT_MODAL: 'embeddededitor-consent-modal',
  POSTER_EDITOR_GUIDES_MODAL: 'poster-editor-guides-modal',
  POSTER_EDITOR_ITEM_LETTER_SPACING_MODAL: 'poster-editor-item-letter-spacing-modal',
  POSTER_EDITOR_TRANSCRIPT_LETTER_CASE_MODAL: 'poster-editor-item-letter-case-modal',
  POSTER_EDITOR_ITEM_LINE_HEIGHT_MODAL: 'poster-editor-item-line-height-modal',
  POSTER_EDITOR_REPLACE_AUDIO_MODAL: 'poster-editor-replace-audio-modal',
  RECORD_IMAGE_AND_VIDEO_MODAL: 'record-image-and-video-modal',
  RECORD_AUDIO_MODAL: 'record-audio-modal',
  CONNECT_SSO_ACCOUNT_MODAL: 'connect-sso-account-modal',
  SOCIAL_POST_DESIGN_ACTION_MODAL: 'social-post-design-action-modal',
  SOCIAL_MEDIA_SELECT_COVER_MODAL: 'social-media-select-cover-modal',
  SOCIAL_MEDIA_ADD_DESIGN_MODAL: 'social-media-add-design-modal',
  MEDIA_TYPE_MODAL: 'media-type-modal',
  AUDIENCE_EDIT_INFO_MODAL: 'audience-edit-info-modal',
  SETTINGS_MODAL: 'settings-modal-react',
  PREMIUM_AGREEMENT_MODAL: 'premium-license-agreement-modal',
  AUTHENTICATE_MODAL: 'auth-modal-react',
  TWO_FACTOR_AUTHENTICATION_VERIFICATION_MODAL: 'two-factor-authentication-verification-modal',
  PASSWORD_VERIFICATION_MODAL: 'password-verification-modal',
  AI_ACTION_LOADING_MODAL: 'ai-action-loading-modal',
  MANAGE_TWO_FACTOR_AUTHENTICATION_MODAL: 'manage-two-factor-authentication-modal',
  BRAND_ACTIVITY_MODAL: 'brand-activity-modal',
  BRAND_COLOR_MODAL: 'brand-color-modal',
  EDIT_POSTER_SUBTITLES_MODAL: 'edit-poster-subtitles-modal',
  EDIT_POSTER_SUBTITLE_MORE_OPTIONS_MODAL: 'edit-poster-subtitle-more-options-modal',
  AI_TEXT_PROMPT_BOX_MODAL: 'ai-text-prompt-box-modal',
  TIMELINE_MODAL: 'timeline-modal',
  PUBLISHING_OPTIONS_MODAL: 'publishing-options-modal',
  PUBLISH_POSTER_MODAL: 'publish-poster-modal',
  ACCOUNT_DELETION_MODAL: 'account-deletion-modal',
  TRANSCRIPT_PRESETS_MODAL: 'transcript-presets-modal',
  EMAIL_CAMPAIGN_DIALOG_MODAL: 'email-campaign-dialog-modal',
  HOMEPAGE_AI_FEATURES_MODAL: 'homepage-ai-features-modal',
  HOMEPAGE_START_CREATING_MODAL: 'homepage-start-creating-modal',
  HOMEPAGE_CREATE_OPTIONS_MODAL: 'homepage-create-options-modal',
  POSTER_EDITOR_RECTANGLE_ROUNDING_MODAL: 'poster-editor-rectangle-rounding-modal',
  BRAND_KIT_UPDATE_FROM_COLOR_PALETTE_MODAL: 'brand-kit-update-from-color-palette-modal',
  POSTER_EDITOR_ROUNDNESS_EFFECT_MODAL: 'poster-editor-roundness-effect-modal',
  EMAIL_CAMPAIGN_PUBLISH_OPTIONS_MODAL: 'email-campaign-publish-options-modal',
  EMAIL_CAMPAIGN_SENDING_OPTIONS_MODAL: 'email-campaign-sending-options-modal',
  USER_SAVE_CONFLICT_MODAL: 'user-save-conflict-modal',
  ADD_MAILING_LIST_MODAL: 'add-mailing-list-modal',
  CREATE_SIGNUP_FORM_MODAL: 'create-signup-form-modal',
  BUSINESS_PROFILES_HOURS_MODAL: 'business-profiles-hours-modal',
  BUSINESS_PROFILES_ACTIVITY_MODAL: 'business-profiles-activity-modal',
  GOOGLE_BUSINESS_PROFILES_IMPORTED_MODAL: 'google-business-profiles-imported-modal',
  AI_SUBTITLES: 'ai-subtitles',
  AI_REMOVE_BG: 'ai-remove-bg',
  AI_ANIMATED_STICKER_SPEED_MODAL: 'ai-animated-sticker-speed-modal',
  AI_SUBTITLE_GENERATION_LANGUAGE_SELECTOR_MODAL: 'ai-subtitle-generation-language-selector-modal',
  SOCIAL_ACCOUNT_CONNECTION_RESPONSE_MODAL: 'social-account-connection-response-modal',
  START_CREATING_MODAL: 'start-creating-modal',
  EDIT_EVENTS_HOME_WIZARD_MODAL: 'edit-events-home-wizard-modal',
  EVENTS_IFRAME_MODAL: 'events-iframe-modal',
  STYLES_INPUT_MODAL: 'styles-input-modal',
  EVENT_PREVIEW_MODAL: 'event-preview-modal',
  EVENTS_SCHEDULE_OPTIONS_MODAL: 'events-schedule-options-modal',
  EMBED_EVENTS_SCHEDULE_MODAL: 'embed-events-schedule-modal',
  CHANGE_EMAIL_TEMPLATE_MODAL: 'change-email-template-modal',
  WEBSITE_BUILDER_SAVE_COMPONENT_TEMPLATE_MODAL: 'website-builder-save-component-template-modal',
  WEBSITE_BUILDER_BLOCK_MANAGER_MODAL: 'website-builder-block-manager-modal',
  WEBSITE_BUILDER_STYLES_MANAGER_MODAL: 'website-builder-styles-manager-modal',
  WEBSITE_BUILDER_SELECT_MEDIA_MODAL: 'website-builder-select-media-modal',
  CONTACT_DETAILS_MODAL: 'contact-details-modal',
  UPSERT_EVENT_REMINDER_MODAL: 'upsert-event-reminder-modal',
  EMBED_EVENT_TO_WEBPAGE_MODAL: 'embed-event-to-webpage-modal',
  EVENT_PROMOTION_USER_ACTION_MODAL: 'event-promotion-user-action-modal',
  EVENT_ONE_CLICK_PROMOTION_MODAL: 'event-one-click-promotion-modal',
  DELETE_EVENT_CONFIRMATION_MODAL: 'delete-event-confirmation-modal',
  SHARE_MODAL: 'share-modal',
  CANCEL_SUBCSRIPTION_MODAL: 'cancel-subscription-modal',
  WEBSITE_BUILDER_EMBED_VIDEO_MODAL: 'website-builder_embed-video-modal',
  SHARE_SIGNUP_FORM_IN_MODAL: 'share-signup-form-in-team-modal',
  MANAGE_EVENT_COLLABORATORS_MODAL: 'manage-event-collaborators-modal',
  POSTER_EDITOR_PAGE_COLOR_PALETTE_STYLES_MODAL: 'poster-editor-page-color-palette-styles-modal',
  WEBSITE_BUILDER_PAGE_MANAGER_MODAL: 'website-builder-page-manager-modal',
  WEBSITE_BUILDER_SETTINGS_MODAL: 'website-builder-settings-modal',
  WEBSITE_BUILDER_COLLABORATE_MODAL: 'website-builder-collaborate-modal',
  PERSONA_MODAL: 'persona-modal',
  POSTER_EDITOR_VERSION_HISTORY_MODAL: 'poster-editor-version-history-modal',
  PREMIUM_PRICING_MODAL: 'premium-pricing-modal',
  AI_REDESIGN_PROMPT_BOX_MODAL: 'ai-redesign-prompt-box-modal',
  DOWNLOAD_MODAL: 'download-modal',
  MY_STUFF_MOBILE_POSTER_PAGE_PREVIEWS_MODAL: 'mystuff-mobile-poster-page-previews-panel-id',
  NOTIFICATIONS_MODAL: 'notifications-modal',
  INACTIVE_USER_PASSWORD_RESET_MODAL: 'inactive-user-password-reset-modal',
  POSTER_EDITOR_PAGE_OPTIONS_MODAL: 'poster-editor-page-options-modal',
  TEMPLATE_PREVIEW_MOBILE_MODAL: 'template-preview-mobile-modal',
  MULTIPAGE_TEMPLATE_SUBMISSION_UNAVAILABLE_MODAL: 'multipage-template-submission-unavailable-modal',
  MULTIPAGE_PREVIEW_THUMBNAIL_SELECTION_MODAL: 'multipage-preview-thumbnail-selection-modal',
  FORM_MAKER_MOBILE_CONTROL_MODAL: 'form-maker-mobile-control-modal',
  FORM_MAKER_PUBLISHING_MODAL: 'form-maker-publishing-modal',
  AI_GENERATION_MODAL: 'ai-generation-modal',
  EMAIL_WIZARD_EMAIL_PREVIEW_MODAL: 'email-wizard-email-preview-modal',
  POSTER_EDITOR_ADD_PAGE_MODAL: 'poster-editor-add-page-modal',
  EMAIL_MAKER_PREVIEW_MODAL: 'email-maker-preview-modal',
  EMAIL_MAKER_MOBILE_CONTROL_MODAL: 'email-maker-mobile-control-modal',
  EMAIL_MAKER_BLOCK_MANAGER_MODAL: 'email-maker-block-manager-modal',
  EMAIL_MAKER_MORE_OPTIONS_MODAL: 'email-maker-more-options-sheet',
  EMAIL_MAKER_SAVE_ERROR_MODAL: 'email-maker-save-error-modal',
  EMAIL_MAKER_COLUMNS_ALL_SHEET: 'email-maker-columns-all-sheet',
  EMAIL_MAKER_COLOR_PICKER_SHEET: 'email-maker-color-picker-sheet',
  EMAIL_MAKER_ADMIN_UPLOAD_HTML_MODAL: 'email-maker-admin-upload-html-modal',
  EMAIL_MAKER_ADMIN_IMAGE_SOURCES_MODAL: 'email-maker-admin-image-sources-modal',
} as const;
